import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { Typography } from '@weave-mui/material';
import { getUtpDatastoreUrl } from 'utils/getUtpDatastoreUrl';

const RETIREMENT_MESSAGE =
  'Data Store in Testing Hub is no longer available. Please use UTP Data Store to claim data, run jobs, and manage test records.';

/**
 * Banner shown on the Testing Hub Data Store page directing users to UTP Data Store.
 */
const DataStoreRetirementBanner = () => {
  const linkUrl = getUtpDatastoreUrl();

  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <Alert
        severity="warning"
        role="alert"
        sx={{
          borderRadius: 1,
          py: 1.25,
          px: 2,
          alignItems: 'center',
          '& .MuiAlert-message': {
            width: '100%',
            py: 0,
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 1,
            width: '100%',
          }}
        >
          <Typography
            variant="body1"
            component="span"
            sx={{ flex: 1, minWidth: 0, fontSize: '1rem' }}
          >
            {RETIREMENT_MESSAGE}
          </Typography>
          <Typography
            variant="body1"
            component="a"
            href={linkUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              fontSize: '1rem',
              fontWeight: 600,
              whiteSpace: 'nowrap',
              color: 'inherit',
            }}
          >
            Open UTP Data Store
          </Typography>
        </Box>
      </Alert>
    </Box>
  );
};

export default DataStoreRetirementBanner;
